import { Model } from './model';

export class SeoPropertiesModel extends Model {
  static ATTR_META_TITLE = 'meta_title';
  static ATTR_META_DESCRIPTION = 'meta_description';
  static ATTR_META_INDEX = 'meta_index';
  static ATTR_META_FOLLOW = 'meta_follow';
  static ATTR_SHOW_ON_SITEMAP = 'show_on_sitemap';
  static ATTR_OG_TITLE = 'og_title';
  static ATTR_OG_DESCRIPTION = 'og_description';
  static ATTR_OG_TYPE = 'og_type';
  static ATTR_OG_URL = 'og_url';
  static ATTR_OG_IMAGE_ID = 'og_image_id';

  get seoTitle() {
    return this.attributes[SeoPropertiesModel.ATTR_SEO_TITLE];
  }

  get seoDescription() {
    return this.attributes[SeoPropertiesModel.ATTR_SEO_DESCRIPTION];
  }

  get seoIndex() {
    return this.attributes[SeoPropertiesModel.ATTR_SEO_INDEX];
  }

  get seoFollow() {
    return this.attributes[SeoPropertiesModel.ATTR_SEO_FOLLOW];
  }

  get seoSitemap() {
    return this.attributes[SeoPropertiesModel.ATTR_SEO_SITEMAP];
  }

  get ogTitle() {
    return this.attributes[SeoPropertiesModel.ATTR_OG_TITLE];
  }

  get ogDescription() {
    return this.attributes[SeoPropertiesModel.ATTR_OG_DESCRIPTION];
  }

  get ogType() {
    return this.attributes[SeoPropertiesModel.ATTR_OG_TYPE];
  }

  get ogUrl() {
    return this.attributes[SeoPropertiesModel.ATTR_OG_URL];
  }

  get ogImageId() {
    return this.attributes[SeoPropertiesModel.ATTR_OG_IMAGE_ID];
  }
}
